import { createFileRoute } from "@tanstack/react-router";
import DaciaHub from "@/pages/hub/DaciaHub";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/dacia-used-cars/")({
  head: () => routeHead("/uk/dacia-used-cars/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DaciaHub />
  );
}
